// Helper to get base URL
const getBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  if (typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:3307';
  }
  return "/api";
};

export const API_BASE_URL = getBaseUrl();

export const API_PATHS = {
  // Auth endpoints
  login: "/users/login",
  auth: {
    google: "/auth/google",
    logout: "/auth/logout",
  },

  // Album endpoints
  albums: {
    all: "/albums/all",
    byCategory: "/albums/category",
    byId: "/albums",
    create: "/albums/create",
    delete: (id: number) => `/albums/delete/${id}`, // DELETE album
    like: (id: number) => `/albums/likes/${id}`, // PATCH like/unlike album (send {action: 'like'|'unlike'})
  },
  photos: { upload: "/photos/upload" },

  // Specific category endpoints
  infographics: "/albums/category/InfoGraphics",
  publications: "/albums/category/Publications",
  radioIllustrations: "/albums/category/RadioIllustrations",
  shortVideos: "/albums/category/ShortVideos",

  articles: {
    base: "/articles",                     // POST create draft, GET list published
    drafts: "/articles/drafts",            // GET list drafts (admin)
    adminById: (id: number) => `/articles/admin/${id}`, // GET article by ID (admin, includes drafts)
    sections: (id: number) => `/articles/${id}/sections`, // PUT sections
    publish: (id: number) => `/articles/${id}/publish`,   // POST publish/unpublish
    bySlug: (slug: string) => `/articles/${slug}`,        // GET public by slug
    uploadCover: "/articles/upload-cover", // POST upload cover image
    uploadFigure: "/articles/upload-figure", // POST upload figure image
    delete: (id: number) => `/articles/${id}`, // DELETE article
  },
  upload: {
    presign: "/upload/presign",
  },
  contact: {
    send: "/contact",
    list: "/contact",
  }
};
